import { createAction } from 'redux-actions'
import {
  CreateTeam$Request,
  DeleteTeams$Request,
  GetCompanyTeams$Request,
  GetDivisions$Request,
  RenameTeam$Request,
  UpdateTeamSettings$Request,
  UpdateDivisionCategorySettings$Request,
  AssignTeamsRandomly$Request,
  GenerateTeams$Request,
  GetAssignRandomTeamsFilters$Request,
  CompanyId,
  DivisionId,
  UserId,
  DivisionCategoryId,
  GetDivisionCategories$Request,
  CreateDivisionCategory$Request,
  DeleteDivisionCategory$Request,
} from '../../../services/api.types'

const ns = 'team-management/'

export const getCompanyTeams = createAction<GetCompanyTeams$Request>(`${ns}GET_COMPANY_TEAMS`)
export const getCompanyTeamsSuccess = createAction<any>(`${ns}GET_COMPANY_TEAMS_SUCCESS`)
export const getCompanyTeamsFail = createAction<any>(`${ns}GET_COMPANY_TEAMS_FAIL`)

/*export const getDivisionsDeprecated = createAction<GetDivisions$Request>(`${ns}GET_COMPANY_GROUPS`)
export const getDivisionsSuccess = createAction<any>(`${ns}GET_COMPANY_GROUPS_SUCCESS`)
export const getDivisionsFail = createAction<any>(`${ns}GET_COMPANY_GROUPS_FAIL`)*/

export const createTeam = createAction<CreateTeam$Request & { silentSuccess: boolean }>(`${ns}CREATE_TEAM`)
export const createTeamSuccess = createAction<any>(`${ns}CREATE_TEAM_SUCCESS`)
export const createGroupSuccess = createAction<any>(`${ns}CREATE_GROUP_SUCCESS`)
export const createTeamFail = createAction<any>(`${ns}CREATE_TEAM_FAIL`)
export const createTeamLoading = createAction<CompanyId | null>(`${ns}CREATE_TEAM_LOADING`)

export const renameTeam = createAction<RenameTeam$Request & { companyId: string }>(`${ns}RENAME_TEAM`)
export const renameTeamSuccess = createAction<any>(`${ns}RENAME_TEAM_SUCCESS`)
export const renameTeamFail = createAction<any>(`${ns}RENAME_TEAM_FAIL`)

export const deleteTeams = createAction<DeleteTeams$Request & { companyId?: CompanyId; silentSuccess?: boolean }>(
  `${ns}DELETE_TEAMS`,
)
export const deleteTeamsSuccess = createAction<any>(`${ns}DELETE_TEAMS_SUCCESS`)
export const deleteTeamsFail = createAction<any>(`${ns}DELETE_TEAMS_FAIL`)
export const deleteTeamsLoading = createAction<CompanyId | null>(`${ns}DELETE_TEAMS_LOADING`)

export const lockTeams = createAction<DeleteTeams$Request>(`${ns}LOCK_TEAMS`)
export const lockTeamsSuccess = createAction<any>(`${ns}LOCK_TEAMS_SUCCESS`)
export const lockTeamsFail = createAction<any>(`${ns}LOCK_TEAMS_FAIL`)

export const unlockTeams = createAction<DeleteTeams$Request>(`${ns}UNLOCK_TEAMS`)
export const unlockTeamsSuccess = createAction<any>(`${ns}UNLOCK_TEAMS_SUCCESS`)
export const unlockTeamsFail = createAction<any>(`${ns}UNLOCK_TEAMS_FAIL`)

export const updateTeamSettings = createAction<UpdateTeamSettings$Request>(`${ns}UPDATE_TEAM_SETTINGS`)
export const updateTeamSettingsSuccess = createAction<any>(`${ns}UPDATE_TEAM_SETTINGS_SUCCESS`)
export const updateTeamSettingsFail = createAction<any>(`${ns}UPDATE_TEAM_SETTINGS_FAIL`)

export const updateDivisionCategorySettings = createAction<UpdateDivisionCategorySettings$Request>(
  `${ns}UPDATE_DIVISION_CATEGORY_SETTINGS`,
)
export const updateDivisionCategorySettingsSuccess = createAction<any>(`${ns}UPDATE_DIVISION_CATEGORY_SETTINGS_SUCCESS`)
export const updateDivisionCategorySettingsFail = createAction<any>(`${ns}UPDATE_DIVISION_CATEGORY_SETTINGS_FAIL`)

export const setCreatedDivisionId = createAction<string | null>(`${ns}SET_CREATED_DIVISION_ID`)
export const setSelectedGroupId = createAction<string | null>(`${ns}SET_SELECTED_GROUP_ID`)
export const setSelectedGroupIdForCompany = createAction<{ companyId: string; groupId: string | null }>(
  `${ns}SET_SELECTED_GROUP_ID_FOR_COMPANY`,
)
export const setSelectedGroupIdForCategory = createAction<{ categoryId: string; groupId: DivisionId | null }>(
  `${ns}SET_SELECTED_GROUP_ID_FOR_CATEGORY`,
)

export const setUserCategoryDivision = createAction<{
  companyId: CompanyId
  userId: UserId
  categoryId: DivisionCategoryId
  divisionId: DivisionId | null
  isAdminView?: boolean
}>(`${ns}SET_USER_CATEGORY_DIVISION`)

export const setUserCategoryDivisionSuccess = createAction(`${ns}SET_USER_CATEGORY_DIVISION_SUCCESS`)
export const setUserCategoryDivisionFail = createAction(`${ns}SET_USER_CATEGORY_DIVISION_FAIL`)

export const assignTeamsRandomly = createAction<AssignTeamsRandomly$Request>(`${ns}ASSIGN_TEAMS_RANDOMLY`)
export const assignTeamsRandomlySuccess = createAction<any>(`${ns}ASSIGN_TEAMS_RANDOMLY_SUCCESS`)
export const assignTeamsRandomlyFail = createAction<any>(`${ns}ASSIGN_TEAMS_RANDOMLY_FAIL`)

export const generateTeams = createAction<GenerateTeams$Request>(`${ns}GENERATE_TEAMS`)
export const generateTeamsSuccess = createAction<any>(`${ns}GENERATE_TEAMS_SUCCESS`)
export const generateTeamsFail = createAction<any>(`${ns}GENERATE_TEAMS_FAIL`)

export const getAssignRandomTeamsFilters = createAction<GetAssignRandomTeamsFilters$Request>(
  `${ns}GET_ASSIGN_RANDOM_TEAMS_FILTERS`,
)
export const getAssignRandomTeamsFiltersSuccess = createAction<any>(`${ns}GET_ASSIGN_RANDOM_TEAMS_FILTERS_SUCCESS`)
export const getAssignRandomTeamsFiltersFail = createAction(`${ns}GET_ASSIGN_RANDOM_TEAMS_FILTERS_FAIL`)

// Action to reset createTeamLoading flag, useful for cleanup on component unmount
export const resetCreateTeamLoading = createAction(`${ns}RESET_CREATE_TEAM_LOADING`)

// Company Groups actions
export const getDivisionCategories = createAction(`${ns}GET_DIVISION_CATEGORIES`)
export const getDivisionCategoriesSuccess = createAction<any>(`${ns}GET_DIVISION_CATEGORIES_SUCCESS`)
export const getDivisionCategoriesFail = createAction<any>(`${ns}GET_DIVISION_CATEGORIES_FAIL`)

export const createDivisionCategory = createAction<CreateDivisionCategory$Request>(`${ns}CREATE_DIVISION_CATEGORY`)
export const createDivisionCategorySuccess = createAction<any>(`${ns}CREATE_DIVISION_CATEGORY_SUCCESS`)
export const createDivisionCategoryFail = createAction<any>(`${ns}CREATE_DIVISION_CATEGORY_FAIL`)

export const deleteDivisionCategory = createAction<DeleteDivisionCategory$Request>(`${ns}DELETE_DIVISION_CATEGORY`)
export const deleteDivisionCategorySuccess = createAction<any>(`${ns}DELETE_DIVISION_CATEGORY_SUCCESS`)
export const deleteDivisionCategoryFail = createAction<any>(`${ns}DELETE_DIVISION_CATEGORY_FAIL`)

export const renameDivisionCategory = createAction<{ groupId: string; companyId: string; customName: string }>(
  `${ns}RENAME_DIVISION_CATEGORY`,
)
export const renameDivisionCategorySuccess = createAction<any>(`${ns}RENAME_DIVISION_CATEGORY_SUCCESS`)
export const renameDivisionCategoryFail = createAction<any>(`${ns}RENAME_DIVISION_CATEGORY_FAIL`)
